/**
 * API Configuration
 * Central configuration for all API endpoints
 */

export const API_BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3002';

export const getAuthHeaders = () => {
  // Auth is handled via httpOnly cookies (withCredentials: true in apiClient)
  // No manual Authorization header needed
  const headers = { 'Content-Type': 'application/json' };
  return headers;
};

export default API_BASE_URL;
